module.exports = __webpack_public_path__ + "img/manage06.0d248f9e.png";